<template>
    <modal-dialog
        id="prospective-filters"
        :show.sync="shown"
        class="uk-modal-dialog-large"
    >
        <template v-slot:title>
            <form class="uk-form uk-grid uk-grid-small" data-uk-grid-margin @submit.prevent>
                <div class=" uk-form-controls-text uk-width-1-2">
                    <h3>
                        Filter List of Projects
                        <slot name="pick-template-button"></slot>
                    </h3>
                </div>
                <div class=" uk-form-controls-text uk-width-1-2 uk-text-right">
                    <h3>
                        <slot name="templates-controls"></slot>
                    </h3>
                </div>
            </form>
        </template>

        <form class="uk-form uk-margin-top">
            <div class="uk-grid uk-grid-small uk-margin-bottom" data-uk-grid-margin>
                <div class="uk-width-1-2">
                    <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                        <div class="uk-width-2-10 lam-label-column uk-text-right">
                            <h5 class="uk-form-controls-text">Status</h5>
                        </div>
                        <div class="uk-width-8-10">
                            <select name="status" :value="state.status" class="uk-width-1-1" @change="filter_by">
                                <option value="">(Any Status)</option>
                                <option v-for="status in availableProjectStatus" :key="status.id" :value="status.code_constant||status.id">{{ status.name }}</option>
                            </select>
                        </div>
                        <!--
                        <div class="uk-width-2-5">
                            <h5 class="uk-text-right">
                                <form-checkbox
                                    id="include_dead"
                                    :checked="state.include_dead"
                                    name="include_dead"
                                    class="uk-margin-small-top"
                                    @input="filter_by_field($event, 'include_dead')"
                                >
                                    Include Dead Projects
                                </form-checkbox>
                            </h5>
                        </div>
                        //-->
                    </div>
                </div>

                <div class="uk-width-2-10">
                    <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                        <div class="uk-width-3-10 lam-label-column uk-text-right">
                            <h5 class="uk-form-controls-text">Studio</h5>
                        </div>
                        <div class="uk-width-7-10">
                            <select name="studio_id" :value="state.studio_id" class="uk-width-1-1" @change="filter_by">
                                <option :value="0">(Any)</option>
                                <option v-for="studio in raw_studio_records" :key="studio.id" :value="studio.id">{{ studio.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="uk-width-3-10">
                    <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                        <div class="uk-width-2-10 lam-label-column uk-text-right">
                            <h5 class="uk-form-controls-text">PIC</h5>
                        </div>
                        <div class="uk-width-2-10">
                            <select name="pic_id" :value="state.pic_id" class="uk-width-1-1" @change="filter_by">
                                <option value="0">(Any)</option>
                                <option v-for="user in users" :key="user.id" :value="user.id">{{ user.initials }}</option>
                            </select>
                        </div>
                        <div class="uk-width-1-10 lam-label-column uk-text-right">
                            <h5 class="uk-form-controls-text">PM</h5>
                        </div>
                        <div class="uk-width-2-10">
                            <select name="pm_id" :value="state.pm_id" class="uk-width-1-1" @change="filter_by">
                                <option value="0">(Any)</option>
                                <option v-for="user in users" :key="user.id" :value="user.id">{{ user.initials }}</option>
                            </select>
                        </div>
                        <div class="uk-width-1-10 lam-label-column uk-text-right">
                            <h5 class="uk-form-controls-text">D</h5>
                        </div>
                        <div class="uk-width-2-10">
                            <select name="d_id" :value="state.d_id" class="uk-width-1-1" @change="filter_by">
                                <option value="0">(Any)</option>
                                <option v-for="user in users" :key="user.id" :value="user.id">{{ user.initials }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="uk-grid uk-grid-small uk-margin-bottom" data-uk-grid-margin>
                <div class="uk-width-1-2">
                    <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                        <div class="uk-width-2-10 lam-label-column uk-text-right">
                            <h5 class="uk-form-controls-text">Architect</h5>
                        </div>
                        <div class="uk-width-8-10">
                            <firm-picker :value="firm?firm.id:0" @pick="$emit('pick-firm', $event)"></firm-picker>
                        </div>
                    </div>
                </div>
                <div class="uk-width-1-2">
                    <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                        <div class="uk-width-1-10 lam-label-column uk-text-right">
                            <h5 class="uk-form-controls-text">State</h5>
                        </div>
                        <div class="uk-width-2-10">
                            <input name="state" :value="state.state" class="uk-width-1-1" @input="debounced_filter_by">
                        </div>
                        <div class="uk-width-1-10 lam-label-column uk-text-right">
                            <h5 class="uk-form-controls-text">City</h5>
                        </div>
                        <div class="uk-width-6-10">
                            <input name="city" :value="state.city" class="uk-width-1-1" @input="debounced_filter_by">
                        </div>
                    </div>
                </div>
            </div>

            <div class="uk-grid uk-grid-small uk-margin-bottom" data-uk-grid-margin>
                <div class="uk-width-1-2">
                    <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                        <div class="uk-width-2-10 lam-label-column uk-text-right">
                            <h5 class="uk-form-controls-text">Year(s)</h5>
                        </div>
                        <div class="uk-width-8-10">
                            <input name="year" :value="state.year" class="uk-width-1-1" @input="debounced_filter_by">
                            <br><span class="uk-text-small uk-text-muted">(Ex: "2018" or "2016-2018" or "2016,2018" - you can use 2 or 4 digits for years)</span>
                        </div>
                    </div>
                </div>

                <div class="uk-width-1-2">
                    <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                        <div class="uk-width-4-10 lam-label-column">
                            <h5 class="uk-text-right">
                                <form-checkbox
                                    id="incentives"
                                    :checked="state.incentives"
                                    name="incentives"
                                    @input="filter_by_field($event, 'incentives')"
                                >
                                    Pursuing incentives
                                </form-checkbox>
                            </h5>
                        </div>
                        <div v-if="prospective" class="uk-width-3-10 lam-label-column">
                            <h5 class="uk-text-right">
                                <form-checkbox
                                    id="unscheduled"
                                    :checked="state.unscheduled"
                                    name="unscheduled"
                                    @input="filter_by_field($event, 'unscheduled')"
                                >
                                    No Schedule
                                </form-checkbox>
                            </h5>
                        </div>
                        <div v-else class="uk-width-6-10 lam-label-column">
                            <h5>
                                <form-checkbox
                                    id="consider_for_marketing"
                                    :checked="state.consider_for_marketing"
                                    name="consider_for_marketing"
                                    @input="filter_by_field($event, 'consider_for_marketing')"
                                >
                                    Consider for Marketing
                                </form-checkbox>
                            </h5>
                        </div>
                        <div v-if="prospective" class="uk-width-3-10 lam-label-column">
                            <h5 class="uk-text-right">
                                <form-checkbox
                                    id="pro_bono"
                                    :checked="state.pro_bono"
                                    name="pro_bono"
                                    @input="filter_by_field($event, 'pro_bono')"
                                >
                                    Pro-bono
                                </form-checkbox>
                            </h5>
                        </div>
                    </div>
                </div>
            </div>

            <div class="uk-grid uk-grid-small uk-margin-bottom" data-uk-grid-margin>
                <div class="uk-width-1-2">
                    <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                        <div class="uk-width-2-10 lam-label-column uk-text-right">
                            <h5 class="uk-form-controls-text">Fee</h5>
                        </div>
                        <div class="uk-width-3-10">
                            <div class="uk-form-icon uk-width-1-1 uk-flex uk-flex-middle">
                                <span class="uk-flex-item-none uk-margin-small-right">$</span>
                                <input
                                    name="fee_min"
                                    :value="state.fee_min"
                                    :min="fee_low"
                                    :max="state.fee_max"
                                    class="uk-flex-item-1"
                                    @focus="$event.target.select()"
                                    @input="debounced_filter_by"
                                />
                            </div>
                            <a href class="uk-text-small uk-text-muted uk-margin-left" @click.prevent="state.fee_min=fee_low">(Min: $ {{ fee_low | nibnut.number("0,0") }})</a>
                        </div>
                        <div class="uk-width-1-10 uk-text-center">
                            <open-icon glyph="arrow-right" />
                        </div>
                        <div class="uk-width-4-10">
                            <div class="uk-form-icon uk-width-1-1 uk-flex uk-flex-middle">
                                <span class="uk-flex-item-none uk-margin-small-right">$</span>
                                <input
                                    name="fee_max"
                                    :value="state.fee_max"
                                    :min="state.fee_min"
                                    :max="fee_high"
                                    class="uk-flex-item-1"
                                    @focus="$event.target.select()"
                                    @input="debounced_filter_by"
                                />
                            </div>
                            <a href class="uk-text-small uk-text-muted uk-margin-left" @click.prevent="state.fee_max=fee_high">(Max: $ {{ fee_high | nibnut.number("0,0") }})</a>
                        </div>
                    </div>
                </div>
                <div class="uk-width-1-2">
                    <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                        <div class="uk-width-1-10 lam-label-column uk-text-right">
                            <h5 class="uk-form-controls-text">Size</h5>
                        </div>
                        <div class="uk-width-3-10">
                            <input
                                name="size_min"
                                :value="state.size_min"
                                :min="size_low"
                                :max="state.size_max"
                                class="uk-width-1-1"
                                @focus="$event.target.select()"
                                @input="debounced_filter_by"
                            />
                            <br><a href class="uk-text-small uk-text-muted" @click.prevent="state.size_min=size_low">(Min: {{ size_low | nibnut.number("0,0")}} <span v-html="sizeUnitHtml"></span>)</a>
                        </div>
                        <div class="uk-width-1-10 uk-text-center">
                            <open-icon glyph="arrow-right" />
                        </div>
                        <div class="uk-width-5-10">
                            <div class="lam-button-group-field">
                                <input
                                    name="size_max"
                                    :value="state.size_max"
                                    :min="state.size_min"
                                    :max="size_high"
                                    class="uk-width-1-1"
                                    @focus="$event.target.select()"
                                    @input="debounced_filter_by"
                                />
                                <div class="uk-button-group" data-uk-button-radio>
                                    <button type="button" class="uk-button" :class="{'uk-active': state.size_units==='SF'}" @click.prevent="units_changed('SF')">Ft<sup>2</sup></button>
                                    <button type="button" class="uk-button" :class="{'uk-active': state.size_units==='SM'}" @click.prevent="units_changed('SM')">M<sup>2</sup></button>
                                    <button type="button" class="uk-button" :class="{'uk-active': state.size_units==='AC'}" @click.prevent="units_changed('AC')">AC</button>
                                </div>
                            </div>
                            <a href class="uk-text-small uk-text-muted" @click.prevent="state.size_max=size_high">(Max: {{ size_high | nibnut.number("0,0") }} <span v-html="sizeUnitHtml"></span>)</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="uk-accordion">
                <h3 v-if="prospective" class="uk-accordion-title">
                    Requests For Materials:
                    <span v-if="!state.request_types || !state.request_types.length">(Any Type)</span>
                    <span v-else>{{ request_type_names }}</span>
                </h3>
                <div v-if="prospective && !!state.request_types" class="uk-accordion-content">
                    <div class="uk-grid uk-grid-small uk-margin-bottom uk-grid-width-1-4">
                        <form-checkbox
                            v-for="request_type in request_types"
                            :key="request_type.code_constant"
                            :id="`request_type-${request_type.code_constant}`"
                            :checked="state.request_types.indexOf(request_type.code_constant)>=0"
                            name="request_types"
                            @input="filter_by_array($event, request_type.code_constant, 'request_types')"
                        >
                            {{ request_type.name }}
                        </form-checkbox>
                    </div>
                </div>

                <h3 class="uk-accordion-title uk-clearfix">
                    Project Types:
                    <span v-if="!state.category_ids || !state.category_ids.length">(Any type)</span>
                    <span v-else>{{ this.category_names }}</span>

                    <div v-if="!!state.category_ids && (state.category_ids.length>1)" class="uk-button-group uk-float-right" data-uk-button-radio>
                        <button type="button" class="uk-button uk-button-small" :class="{'uk-active': state.category_ids_operator==='&'}" @click.prevent="state.category_ids_operator='&'">AND</button>
                        <button type="button" class="uk-button uk-button-small" :class="{'uk-active': state.category_ids_operator==='|'}" @click.prevent="state.category_ids_operator='|'">OR</button>
                    </div>
                </h3>
                <div class="uk-accordion-content">
                    <category-picker-list
                        id="project-list"
                        :parent="null"
                        :selected-ids="state.category_ids || []"
                        :required-sections="[]"
                        @pick="filter_by_categories"
                    />
                </div>
            </div>
        </form>
    </modal-dialog>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"
import orderBy from "lodash/orderBy"
import debounce from "lodash/debounce"

import string_utilities from "../../../mixins/StringUtilities"

import ModalDialog from "../../../dialogs/ModalDialog/ModalDialog"
import FormCheckbox from "../../../ui/FormCheckbox"
import OpenIcon from "../../../ui/OpenIcon"
import FirmPicker from "../../../ui/FirmPicker"
import CategoryPickerList from "../../../ui/CategoryPickerList"

export default {
    mixins: [string_utilities],
    components: {
        ModalDialog,
        FormCheckbox,
        OpenIcon,
        FirmPicker,
        CategoryPickerList
    },
    methods: {
        filter_by_field (value, field) {
            this.$emit("filter", value, field)
        },
        filter_by (event) {
            let value = event.target.value
            if(event.target.name.match(/_id$/i)) value = parseInt(value)
            this.filter_by_field(value, event.target.name)
        },
        debounced_filter_by: debounce(function (event) {
            this.filter_by(event)
        }, 500),
        filter_by_array (selected, value, field) {
            const values = this.state[field].slice()
            const index = values.indexOf(value)
            if(selected && (index < 0)) values.push(value)
            else if(!selected && (index >= 0)) values.splice(index, 1)
            this.filter_by_field(values, field)
        },
        filter_by_categories (selected, category_id) {
            this.filter_by_array(selected, category_id, "category_ids")
        },
        standardized_size (size, units, standard_units) {
            if(units === standard_units) return size
            if(standard_units === "SM") {
                if(units === "AC") return size * 4046.86 // AC -> SM
                return size * 0.093 // SF -> SM
            }
            if(units === "AC") return size * 43560 // AC -> SF
            return size * 10.76 // SM -> SF
        },
        units_changed (units) {
            this.$emit("units-changed", units)
            // this.stateUi.size_min = this.size_low
            // this.stateUi.size_max = this.size_high
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        shown: {
            get: function () {
                return this.show
            },
            set: function (show) {
                if(!show) this.$emit("update:show", false)
            }
        },
        raw_studio_records () {
            return this.entity_records("studio")
        },
        raw_user_records () {
            return this.entity_records("user").filter(user => {
                return !user.deleted_at
            })
        },
        raw_category_records () {
            return this.entity_records("category")
        },
        raw_firm_records () {
            return this.entity_records("firm")
        },
        users () {
            return orderBy(this.raw_user_records, "initials", "asc")
        },
        firm () {
            if(this.state.firm_id) return this.raw_firm_records.find(firm => firm.id === this.state.firm_id)
            return null
        },
        fee_low () {
            if(!this.state.query_info || !this.state.query_info.fee_range) return 0
            return this.state.query_info.fee_range[0]
        },
        fee_high () {
            if(!this.state.query_info || !this.state.query_info.fee_range) return 0
            return this.state.query_info.fee_range[1]
        },
        size_low () {
            if(!this.state.query_info || !this.state.query_info.size_range) return 0
            return this.standardized_size(this.state.query_info.size_range[0], "SF", this.state.size_units)
        },
        size_high () {
            if(!this.state.query_info || !this.state.query_info.size_range) return 0
            return this.standardized_size(this.state.query_info.size_range[1], "SF", this.state.size_units)
        },
        request_types () {
            return this.dictionary("request_for_material")
        },
        category_names () {
            if(!this.raw_category_records || !this.state.category_ids || !this.state.category_ids.length) return ""

            return this.raw_category_records
                .filter(category => this.state.category_ids.indexOf(category.id) >= 0)
                .map(category => category.name).join((this.stateUi.category_ids_operator === "&") ? " & " : " | ")
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        prospective: {
            required: true
        },
        state: {
            required: true
        },
        stateUi: {
            required: true
        },
        availableProjectStatus: {
            required: true
        },
        sizeUnitHtml: {
            required: true
        }
    }
}
</script>
